
import { create } from 'zustand';

export const useCrisisEventStore = create((set) => ({
    crises: [],
    recoveryActivities: [],
    improvementActions: [],
    uniqueValues: {},
    selectedCrisis: null,

    loadingCrises: false,
    loadingDetail: false,
    loadingRecovery: false,
    loadingImprovement: false,
    isSubmitting: false,

    paginationCrises: {
        currentPage: 1,
        itemsPerPage: 10,
        totalItems: 0,
        totalPages: 0,
        hasNextPage: false,
        hasPreviousPage: false
    },
    paginationRecovery: {
        currentPage: 1,
        itemsPerPage: 10,
        totalItems: 0,
        totalPages: 0,
        hasNextPage: false,
        hasPreviousPage: false
    },
    paginationImprovement: {
        currentPage: 1,
        itemsPerPage: 10,
        totalItems: 0,
        totalPages: 0,
        hasNextPage: false,
        hasPreviousPage: false
    },

    error: null,

    stats: null,
    loadingStats: false,

    // Setters
    setCrisisEvents: (items) => set({ crises: items }),
    setRecoveryActivities: (items) => set({ recoveryActivities: items }),
    setImprovementActions: (items) => set({ improvementActions: items }),
    setUniqueValues: (uniqueValues) => set({ uniqueValues: uniqueValues || {} }),
    setStats: (stats) => set({ stats }),

    setLoadingCrises: (loading) => set({ loadingCrises: loading }),
    setLoadingDetail: (loading) => set({ loadingDetail: loading }),
    setLoadingRecovery: (loading) => set({ loadingRecovery: loading }),
    setLoadingImprovement: (loading) => set({ loadingImprovement: loading }),
    setLoadingStats: (loading) => set({ loadingStats: loading }),
    setIsSubmitting: (isSubmitting) => set({ isSubmitting }),

    setPaginationCrises: (pagination) => set((state) => ({
        paginationCrises: { ...state.paginationCrises, ...pagination }
    })),
    setPaginationRecovery: (pagination) => set((state) => ({
        paginationRecovery: { ...state.paginationRecovery, ...pagination }
    })),
    setPaginationImprovement: (pagination) => set((state) => ({
        paginationImprovement: { ...state.paginationImprovement, ...pagination }
    })),

    setError: (error) => set({ error }),
    clearError: () => set({ error: null }),

    setSelectedCrisis: (crisis) => set({ selectedCrisis: crisis }),
    clearSelectedCrisis: () => set({ selectedCrisis: null }),

    selectedItem: null,
    openForm: (item = null) => set({ selectedItem: item }),
    closeForm: () => set({ selectedItem: null }),
}));
